import axios from 'axios';
import config from '../config/apiConfig';

// --- CONFIGURACIÓN BASE ---
const API_BASE_URL = `${config.api_url}/api/pedidos`; // URL base para /api/pedidos
const getHeaders = () => ({
    'Content-Type': 'application/json',
    'token': localStorage.getItem('token')
});


const getUrl = (path) => {
        const base = config.api_url.endsWith('/') ? config.api_url : `${config.api_url}/`;
        const rumb = path.startsWith('/') ? path.substring(1) : path;
        return base + rumb;
};


// 1.1 REGISTRO DESDE TPV (usa fetch)
export const registrarPedidoTPV = async (pedidoData) => {
    try {
        const response = await fetch(getUrl(`api/pedidos/registrar_tpv`), {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify(pedidoData)
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Error al registrar pedido TPV');
        }

        return await response.json();
    } catch (error) {
        console.error("Error en registrarPedidoTPV:", error);
        throw error;
    }
};

// 1.2 REGISTRO DESDE WEB (usa axios)
// En services/pedidosServicio.js

export const registrarPedidoWeb = async (pedidoData, comprobanteFile = null) => {
    try {
        let url = `${API_BASE_URL}/registrar_web`;
        let options = {};

        if (comprobanteFile) {
            // Si hay comprobante, usar FormData
            const formData = new FormData();
            Object.keys(pedidoData).forEach(key => {
                if (key === 'items') {
                    formData.append(key, JSON.stringify(pedidoData[key]));
                } else {
                    formData.append(key, pedidoData[key]);
                }
            });
            formData.append('comprobante', comprobanteFile);
            options = { method: "POST", body: formData };
        } else {
            // Sin comprobante, JSON normal como antes
            options = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(pedidoData)
            };
        }

        const response = await fetch(url, options);

        // Intentamos leer JSON siempre
        const data = await response.json().catch(() => ({}));

        // 🔒 BLOQUEO (403) → RESPUESTA NORMAL
        if (response.status === 403) {
            return {
                status: "blocked",
                message: data.message || "Su número está bloqueado por el local."
            };
        }

        // ❌ OTRO ERROR HTTP
        if (!response.ok) {
            return {
                status: "error",
                message: data.message || `Error (${response.status})`
            };
        }

        // ✅ OK
        return data;

    } catch (err) {
        return {
            status: "error",
            message: "No se pudo conectar con el servidor."
        };
    }
};



// 2.1 CONSULTAR ESTADO (POLLING) (usa axios)
export const consultarEstadoPedido = async (pedidoId) => {
    try {
        const res = await axios.get(`${config.api_url}/api/pedido/estado/${pedidoId}`);
        console.log('respuesta', res)
        return res.data;
    } catch (error) {
        console.error("Error al consultar estado:", error);
        return null;
    }
};

// 2.2 OBTENER HISTORIAL (usa fetch)
export const obtenerListadoPedidos = async (inicio, fin) => {
    const token = localStorage.getItem('token');

    const url = `${config.api_url}/api/pedidos/historial?inicio=${inicio}&fin=${fin}`;
    console.log(url)
    const res = await fetch(url, { headers: { 'token': token } });

    if (!res.ok) {
        throw new Error("Fallo al obtener el historial de pedidos.");
    }

    return await res.json();
};


// --- 3. ACCIONES DE ADMIN (ANULAR / BLOQUEAR / PAGAR) (usa fetch) ---

// 3.1 ANULAR PEDIDO (usa fetch)
export const anularPedidoApi = async (id) => {
    try {
        const response = await fetch(`${API_BASE_URL}/${id}/anular`, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify({ motivo: "Anulado manualmente desde KDS" })
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Error al anular el pedido');
        }

        return data;
    } catch (error) {
        console.error("Error en servicio anularPedidoApi:", error);
        throw error;
    }
};

// 3.1b CAMBIAR ESTADO (usa fetch)
export const cambiarEstadoPedidoApi = async (id, nuevoEstadoId) => {
    const response = await fetch(`${config.api_url}/api/v1/pedidos/${id}/cambiar_estado`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({ nuevoEstadoId })
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
        throw new Error(data.error || 'Error al cambiar el estado del pedido');
    }

    return data;
};

// 3.2 CONFIRMAR PAGO (usa fetch)
export const confirmarPagoPedidoApi = async (pedidoId, metodoPago) => {
    const response = await fetch(`${config.api_url}/api/v1/pedidos/${pedidoId}/confirmar_pago`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({ metodo_pago: metodoPago })
    });
    return await response.json();
};

// 3.3 BLOQUEAR CLIENTE (usa fetch)
export const bloquearCliente = async (telefono, razon) => {
    const telefono_formateado = "+56" + telefono.replace(/[^\d]/g, '').slice(-9);

    const res = await fetch(`${config.api_url}/api/clientes/bloquear`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({
            telefono: telefono_formateado,
            razon: razon || 'Bloqueo manual por administrador'
        })
    });

    if (!res.ok) {
        const errorData = await res.json().catch(() => ({ message: 'Error desconocido del servidor.' }));
        throw new Error(errorData.message || 'Error al bloquear el cliente.');
    }

    return await res.json();
};

// 🚩 NOTA: Eliminé la función registrarPedidoTPV_ y el import de axios en registrarPedidoTPV

// --- NUEVO ENDPOINT PARA MESAS ---
export const registrarPedidoMesa = async (pedidoData) => {
 
    try {
        // CORRECCIÓN AQUÍ: Usamos getUrl que ya arma bien la URL base
        const response = await fetch(`${config.api_url}/api/v1/pedidos/mesa`, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify(pedidoData)
        });
        console.log("respuesta servidor", response)
        if (!response.ok) {
            // Si Flask revienta, evitamos que rompa el JSON.parse()
            const contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                const error = await response.json();
                throw new Error(error.error || 'Error al registrar pedido en la mesa');
            } else {
                throw new Error('El servidor no respondió correctamente (Error 500 o 404). Revisa Flask.');
            }
        }

        return await response.json();
    } catch (error) {
        console.error("Error en registrarPedidoMesa:", error);
        throw error;
    }
};


export const obtenerPrecuentaMesa = async (mesaId) => {
    try {
        const response = await fetch(`${config.api_url}/api/v1/pedidos/mesa/${mesaId}/precuenta` ,{
        method: 'GET',
        headers: getHeaders(),
        });
        console.log("obtener pre cuenta", response)
        if (!response.ok) throw new Error('No hay cuenta activa');
        return await response.json();
    } catch (error) {
        console.error(error);
        return null;
    }
};

export const confirmarPagoMesa = async (mesaId, datosPago) => {
    try {
        const token = localStorage.getItem("token");
        const baseUrl = config.api_url.replace(/\/$/, "");
        const res = await fetch(`${baseUrl}/api/v1/pedidos/mesa/${mesaId}/confirmar_pago`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'token': token },
            body: JSON.stringify(datosPago)
        });
        return await res.json();
    } catch (e) {
        console.error("Error confirmando pago mesa:", e);
        throw e;
    }
};

// --- NUEVO ENDPOINT PÚBLICO PARA PEDIDOS QR EN MESA ---
export const registrarPedidoMesaPublico = async (pedidoData) => {
    try {
        const response = await fetch(`${config.api_url}/api/public/pedidos/mesa`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(pedidoData)
        });
        const data = await response.json();
        if (!response.ok) {
            return { status: 'error', message: data.message || 'Error al enviar pedido' };
        }
        return data;
    } catch (err) {
        return { status: 'error', message: 'Error de conexión con el servidor.' };
    }
};

export const obtenerDetalleMesa = async (mesaId) => {
    const token = localStorage.getItem("token");
    const res = await fetch(`${config.api_url}/api/v1/pedidos/mesa/${mesaId}/detalle`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'token': token
        }
    });
    return await res.json();
};

// ==============================================================================
// 📱 VALIDACIÓN SMS
// ==============================================================================

/**
 * Envía un código de validación SMS al teléfono.
 * @param {string} telefono - Número en formato +569XXXXXXXX
 * @returns {Promise<{status: string, message: string}>}
 */
export const enviarCodigoValidacion = async (telefono) => {
    try {
        const response = await fetch(`${config.api_url}/api/validacion/enviar_codigo`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ telefono })
        });
        const data = await response.json();
        return data;
    } catch (err) {
        return { status: 'error', message: 'Error de conexión.' };
    }
};

/**
 * Verifica el código ingresado por el usuario.
 * @param {string} telefono - Número en formato +569XXXXXXXX
 * @param {string} codigo - Código de 6 dígitos
 * @returns {Promise<{status: string, message: string}>}
 */
export const verificarCodigoValidacion = async (telefono, codigo) => {
    try {
        const response = await fetch(`${config.api_url}/api/validacion/verificar_codigo`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ telefono, codigo })
        });
        const data = await response.json();
        return data;
    } catch (err) {
        return { status: 'error', message: 'Error de conexión.' };
    }
};

/**
 * Verifica si un teléfono ya está validado (sin enviar código).
 * @param {string} telefono - Número en formato +569XXXXXXXX
 * @returns {Promise<{status: string}>}
 */
export const verificarTelefonoValidado = async (telefono) => {
    try {
        const response = await fetch(`${config.api_url}/api/validacion/verificar_telefono`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ telefono })
        });
        const data = await response.json();
        return data;
    } catch (err) {
        return { status: 'error' };
    }
};


